import ButtonLoadingContent from '../../../shared/Loading/ButtonLoadingContent';
import AsyncButton from '../../../shared/Loading/AsyncButton';

const Actions = ({
  mode,
  user,
  notEditor,
  loading,
  acceptedPolicy,
  identificationConfirmed = true,
  onBackToLogin,
  onClose,
  modified,
  desModified,
}) => {
  if (mode === 'create') {
    const registerDisabled = !acceptedPolicy || loading || !identificationConfirmed;
    return (
      <div>
        <button
          type="submit"
          className={`w-full text-white text-base py-2 transition border border-transparent rounded
            ${registerDisabled
              ? 'bg-purple-200 cursor-not-allowed'
              : 'bg-personalized hover:bg-white hover:text-personalized hover:border-personalized'
            }`}
          disabled={registerDisabled}
        >
          <ButtonLoadingContent loading={loading}>Registrarme</ButtonLoadingContent>
        </button>
        {!onClose && (
          <div className="mt-4 text-center text-sm">
            <button
              onClick={onBackToLogin}
              className={`w-full text-base py-2 transition rounded
                ${loading
                  ? 'bg-purple-200 cursor-not-allowed text-white'
                  : 'bg-personalized text-white border border-transparent hover:bg-white hover:text-personalized hover:border-personalized'
                }`}
              disabled={loading}
            >
              Ya tengo una cuenta
            </button>
          </div>
        )}
      </div>
    );
  }
  if ((mode === 'get' || mode === 'view') && !user) {
    return (
      <div>
        {!notEditor && (
          <div className="mt-4 text-center text-sm">
            <button
              type="submit"
              className={`w-full text-white text-base py-2 transition border border-transparent rounded
                ${loading
                  ? 'bg-purple-200 cursor-not-allowed'
                  : 'bg-personalized hover:bg-white hover:text-personalized hover:border-personalized'
                }`}
              disabled={loading}
            >
              <ButtonLoadingContent loading={loading}>Actualizar</ButtonLoadingContent>
            </button>
          </div>
        )}
        {mode === 'get' && (
          <div className="mt-4 text-center text-sm">
            <AsyncButton
              onClick={desModified}
              className={`w-full text-base py-2 transition rounded
                ${loading
                  ? 'bg-purple-200 cursor-not-allowed text-white'
                  : 'bg-personalized text-white border border-transparent hover:bg-white hover:text-personalized hover:border-personalized'
                }`}
            >
              Visualizar
            </AsyncButton>
          </div>
        )}
      </div>
    );
  }
  if (mode === 'get' && user) {
    return (
      <div className="mt-4 text-center text-sm">
        <AsyncButton
          onClick={modified}
          className="w-full bg-personalized text-white text-base py-2 transition border border-transparent rounded hover:bg-white hover:text-personalized hover:border-personalized"
        >
          Modificar información
        </AsyncButton>
      </div>
    );
  }
  return null;
};

export default Actions;
